/**
 * sessionStorage 工具
 */
export const session = {
  get(key) {
    return sessionStorage.getItem(key)
  },
  set(key, value) {
    return sessionStorage.setItem(key, value)
  },
  remove(key) {
    return sessionStorage.removeItem(key)
  }
}

/**
 * localStorage 工具
 */
export const local = {
  get(key) {
    return localStorage.getItem(key)
  },
  set(key, value) {
    return localStorage.setItem(key, value)
  },
  remove(key) {
    return localStorage.removeItem(key)
  }
}



// WEBPACK FOOTER //
// ./src/common/storage.js